
import Coin from "../../../assets/duotone/Coin.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CoinIcon({ className, dataTestid = "CoinIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Coin data-testid={dataTestid} className={classes} {...rest} />
  );
}
